import React from 'react';

export default function LogoMark({ size = 28 }) {
  return (
    <span
      className="logo-mark"
      style={{ width: size, height: size, fontSize: size * 0.58 }}
      aria-hidden="true"
    >
      ✦
    </span>
  );
}
